import React from 'react';
import './TypingIndicator.css';

/** Three dots shown between sending and the first token arriving. */
const TypingIndicator = () => (
    <div className='chat-bubble-row chat-bubble-row--assistant'>
        <div className='typing-indicator'>
            <span />
            <span />
            <span />
        </div>
    </div>
);

export default TypingIndicator;
